import { render, staticRenderFns } from "./ClienteFormulario.vue?vue&type=template&id=790a09a0&scoped=true"
import script from "./ClienteFormulario.vue?vue&type=script&lang=js"
export * from "./ClienteFormulario.vue?vue&type=script&lang=js"
import style0 from "./ClienteFormulario.vue?vue&type=style&index=0&id=790a09a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a09a0",
  null
  
)

export default component.exports